export const baseFormColumn = (ctx) => {
  return [
    {
      prop: 'companyCode',
      name: '公司',
      type: 'select',
      label: 'personCompanyName',
      value: 'personCompanyCode',
      options: ctx.companyList || [],
      changeMethod: 'changeMethod',
    },
    {
      prop: 'applyDepartment',
      name: '业务部门',
      type: 'select',
      options: ctx.departmentList,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
    },
    {
      prop: 'contractAmount',
      name: '合同金额',
      type: 'inputNumber',
      append: '元',
      maxlength: 20,
      precision: 6,
    },
    {
      prop: 'contractUnitAmount',
      name: '合同单价',
      type: 'inputNumber',
      append: '元',
      max: 9999999999.99,
      precision: 2,
    },
    {
      prop: 'contractQuantity',
      name: '合同数量',
      type: 'inputNumber',
      append: '吨',
      maxlength: 20,
      precision: 6,
    },
    {
      prop: 'contractCode',
      name: '合同编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      prop: 'contractTitle',
      name: '合同类型',
      type: 'select',
      options: ctx.contractTitleList,
    },
    {
      prop: 'contractType',
      name: '合同类别',
      type: 'select',
      options: ctx.contractTypeList,
    },
    {
      prop: 'supplierNo',
      name: '供应商名称',
      type: 'searchTableSpec',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
        departmentCode: ctx.baseFormData.departmentCode, //部门
        companyCode: ctx.baseFormData.companyCode, //公司
      },
      currentValue: ctx.baseFormData.supplierName ? ctx.baseFormData.supplierName : null,
      isMultiple: true,
      disabled: ctx.baseFormData.applyDepartment ? false : true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'salesmanNo',
      name: '部门负责人',
      placeholder: '请选择部门负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      extraData: {
        personCompanyCode: ctx.userInfo.companyCode,
      },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseFormData?.salesmanName,
    },
    {
      prop: 'projectNo',
      name: '立项编号',
      type: 'searchTableSpec',
      searchType: 'projectListWumao',
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        platformtCompany: ctx.baseFormData.companyCode,
        platformtCompanyName: ctx.baseFormData.companyName,
        applyCompanyName: ctx.baseFormData.companyName,
        applyCompanyNo: ctx.baseFormData.companyCode,
      },
      currentValue: ctx.baseFormData?.projectNo ? ctx.baseFormData?.projectNo : null,
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      disabled: true,
      placeholder: ctx.baseFormData.projectName === '' ? null : '自动带出项目名称',
    },
    {
      prop: 'signDate',
      name: '合同签署日期',
      type: 'date',
    },
    {
      prop: 'dateStart',
      name: '合同开始日期',
      type: 'startDaterangePicker',
    },
    {
      prop: 'dateEnd',
      name: '合同结束日期',
      type: 'endDaterangePicker',
    },
    {
      prop: 'isViolationResponsibility',
      name: '是否有违约责任',
      type: 'checkbox',
      falseLable: '0',
      trueLable: '1',
      labelPosition: 'right',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractPenaltyTypeCode',
      name: '合同违约金类型',
      type: 'select',
      options: ctx.contractPenaltyTypeList, //FIXED固定值;RATE利率
      changeMethod: 'changeMethod',
      isHidden: !ctx.isPenaltyType,
    },
    {
      prop: 'penaltyTypeValue',
      name: '违约金固定值',
      type: 'inputNumber',
      append: '元',
      maxlength: 20,
      precision: 2,
      isHidden: !ctx.isPenaltyType || (ctx.contractPenaltyTypeCode == 'FIXED' ? false : true),
    },
    {
      prop: 'penaltyDailyRate',
      name: '违约金日利率',
      maxlength: 20,
      type: 'inputNumber',
      append: '%',
      precision: 2,
      isHidden: !ctx.isPenaltyType || (ctx.contractPenaltyTypeCode == 'RATE' ? false : true),
    },
    {
      prop: 'operaterName',
      name: '经办人',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'remark',
      name: '备注',
      type: 'input',
    },
  ];
};

export const baseFormRules = () => {
  return {
    companyCode: [{ required: true, message: '公司必填', trigger: ['change', 'blur'] }],
    applyDepartment: [{ required: true, message: '业务部门必填', trigger: ['change', 'blur'] }],
    contractType: [{ required: true, message: '合同类别必填', trigger: ['change', 'blur'] }],
    supplierNo: [{ required: true, message: '供应商名称必填', trigger: ['change', 'blur'] }],
    contractName: [{ required: true, message: '合同名称必填', trigger: 'blur' }],
    contractAmount: [{ required: true, message: '合同金额必填', trigger: ['change', 'blur'] }],
    contractQuantity: [{ required: true, message: '合同数量必填', trigger: ['change', 'blur'] }],
    salesmanNo: [{ required: true, message: '部门负责人必填', trigger: ['change', 'blur'] }],
    dateStart: [{ required: true, message: '合同开始日期必填', trigger: ['change', 'blur'] }],
    dateEnd: [{ required: true, message: '合同结束日期必填', trigger: ['change', 'blur'] }],
    signDate: [{ required: true, message: '合同签署日期必填', trigger: ['change', 'blur'] }],
  };
};
